<template>
    <tr>
        <td>
            {{ partition.name }}
            <div class="items" v-if="partition.grouped_partitions">
                <div class="item" v-for="grouped_partition in partition.grouped_partitions">
                    {{ grouped_partition.name }}
                </div>
            </div>
        </td>
        <td>
            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 起始： -->
                {{ $t('models.attributes.partitions.numbers_from') }}：
            </span>{{ partition.numbers_from }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 結尾： -->
                {{ $t('models.attributes.partitions.numbers_to') }}：
            </span>{{ partition.numbers_to }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 總數量： -->
                {{ $t('ui.pages.partitions.total_amount') }}：
            </span>{{ $store.getters[store_key+'number_with_commas'](partition.numbers_amount) }}<br>

            <span style="font-weight: bold;font-size: 1.1em;">
                <!-- 可用數量： -->
                {{ $t('ui.pages.partitions.available_quantity') }}：
            </span>{{ $store.getters[store_key+'number_with_commas'](partition.remaining_numbers) }}

        </td>
        <td>
            <div class="ui items">
                <router-link class="item" v-for="(child_partition, index) in partition.child_partitions"
                    :key="child_partition.identity"
                    :to="{
                        name: 'edit_partition',
                        params: {
                            partition_identity: child_partition.identity
                        }
                    }">
                    {{ index + 1 }}. {{ child_partition.name }}
                </router-link>
            </div>
        </td>
        <td>
            <router-link v-if="$store.getters[store_key+'current_customer'](partition)" :to="{name: 'customer', params: {customer_identity: $store.getters[store_key+'current_customer'](partition).identity}}">
                {{ $store.getters[store_key+'current_customer'](partition).company_short_name || $store.getters[store_key+'current_customer'](partition).identity }}
            </router-link>
            <div v-else>
                <!--
                    automatic_number 自動取號,
                    use_yourself 自用
                -->
                {{
                    partition.partition_type == "Auto"
                    ? $t('ui.pages.partitions.automatic_number')
                    :provider_node.company_short_name
                }}
            </div>
        </td>
        <td>{{ partition.note }}</td>
    </tr>
</template>

<script>
export default {
    name: "AssociatedPartitionRow",
    props: {
        partition: Object
    },
    data() {
        return {
            is_loading: false,
            is_deleting: false,
            store_key: 'provider/partitions_module/'
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    computed: {
        current_store: (instance) => instance.$store.state.provider.partitions_module,
        provider_node: (instance) => instance.$store.state.provider.node,
    },
    components: {
    }
}
</script>
